import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const NoAccess = ({ homePath = "/settings" }) => (
	<div className="flex flex-col items-center justify-center text-center py-24 px-4">
		<div className="h-14 w-14 rounded-full bg-[#1b3b5f]/10 flex items-center justify-center mb-4">
			<Lock size={24} color="#1b3b5f" />
		</div>
		<h1 className="text-xl font-bold text-gray-800 mb-2">
			You don&apos;t have access to this page
		</h1>
		<p className="text-sm text-gray-500 max-w-md mb-6">
			Your role doesn&apos;t include this page. Ask a super admin to update
			your role if you need it.
		</p>
		<Link
			to={homePath}
			className="h-10 px-5 inline-flex items-center rounded-md bg-[#1b3b5f] text-white text-sm font-semibold"
		>
			Go to a page you can open
		</Link>
	</div>
);

export default NoAccess;
